import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { config } from "../../constants/domainConfig";
import { Container, Row, Col, Button, Form, Input } from 'reactstrap';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { setHeaderTitle } from '../../actions/HeaderActions';
import { FormattedMessage } from 'react-intl';
import { console_log } from '../../utils/helper';

class StaticPages extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: ''
        };
    }

    componentWillMount() {
        switch (this.props.location.pathname) {
            case "/about":
                this.props.setHeaderTitle("About Us");
                this.setState({
                    type: "about"
                });
                break;
            case "/privacy-policy":
                if (config.lang == 'no') {
                    this.props.setHeaderTitle("PERSONVERNPOLICY");
                }
                else if(config.subDomain=='tr'){
                    this.props.setHeaderTitle("Gizlilik Politikası");
                }
                else {
                    this.props.setHeaderTitle("Privacy Policy");
                } 
                this.setState({
                    type: "privacy-policy"
                });
                break;
            case "/terms-conditions":
                this.props.setHeaderTitle("Terms And Conditions");
                this.setState({
                    type: "terms-conditions"
                });
                break;
        }
        this.props.show();
        setTimeout(() => {
            this.props.hide();
        }, 1000);
    }

    componentDidMount() {
       
        if(config.subDomain.includes('mobiofit')){
            document.body.classList.add("gradient-bg-mobiofit");
        }
        else{
            document.body.classList.add("gradient-bg");
        }
       
        window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps) {
        switch (nextProps.location.pathname) {
            case "/about":
                nextProps.setHeaderTitle("About Us");
                this.setState({
                    type: "about"
                });
                break;
            case "/privacy-policy":
                if(config.lang == 'no') {
                    nextProps.setHeaderTitle("PERSONVERNPOLICY");
                }
                else if(config.lang == 'ar') {
                    nextProps.setHeaderTitle("سياسة الخصوصية");
                }
                else if(config.subDomain == 'sn') {
                    nextProps.setHeaderTitle("Politique de confidentialité");
                }
                else if(config.subDomain == 'ee') {
                    nextProps.setHeaderTitle("Privaatsuse õigused");
                }
                else if(config.subDomain == 'tr') {
                    nextProps.setHeaderTitle("Gizlilik Politikası");
                }
                else if(config.subDomain == 'lv') {
                    nextProps.setHeaderTitle("Privātuma politika");
                }
                else if(config.subDomain == 'lt') {
                    nextProps.setHeaderTitle("Privatumo politika");
                }
                else if(config.subDomain == 'rs') {
                    nextProps.setHeaderTitle("Приватност");
                }
                else if(config.subDomain == 'th') {
                    nextProps.setHeaderTitle("นโยบายความเป็นส่วนตัว");
                }
                else if(config.subDomain == 'gr'){
                    nextProps.setHeaderTitle("ΠΟΛΙΤΙΚΗ ΑΠΟΡΡΗΤΟΥ")
                }
                else if(config.subDomain == 'ch'){
                    nextProps.setHeaderTitle("DATENSCHUTZRECHTE")
                }
                else if(config.lang == 'fr'){
                    nextProps.setHeaderTitle("Politique de confidentialité")
                }
                else if(config.lang == 'cs'){
                    nextProps.setHeaderTitle("ZÁSADY OCHRANY OSOBNÍCH ÚDAJŮ")
                }
                else if(config.lang === "es"){
                    nextProps.setHeaderTitle("Política de privacidad")
                }
                else if(config.lang === 'pt'){
                    nextProps.setHeaderTitle("Política de Privacidade")
                }
                else {
                    nextProps.setHeaderTitle("Privacy Policy");
                }
                this.setState({
                    type: "privacy-policy"
                });
                break;
            case "/terms-conditions":
                nextProps.setHeaderTitle("Terms And Conditions");
                if(config.subDomain == 'rs') {
                    nextProps.setHeaderTitle("Услови коришћења");
                }
                this.setState({
                    type: "terms-conditions"
                });
                break;
        }
        if (this.props.location.pathname != nextProps.location.pathname) {
            this.props.show();
            setTimeout(() => {
                this.props.hide();
            }, 500);
        }
    }

    componentDidUpdate() {
        window.scrollTo(0, 0);
    }

    componentWillUnmount() {
        document.body.classList.remove("gradient-bg");
        document.body.classList.remove("gradient-bg-mobiofit");
    }

    __getAboutUsPage() {
        return (
			<section className="about">
				<div className="about-inner">
					<Container fluid>
						<Row className="text-center">
							<Col xs="12">
								<div className="logo-wrap">
                                {config.title == 'bidiotv' && config.mainDomain != 'mobiotv' ? <img className="img-fluid" src="./img/logo/bidiotv-logo.png" alt="BidioTV" />
                                    :<img className="img-fluid" src="./img/logo.png" alt="MobioTV" />
                                }
								</div>
                                {config.title == 'bidiotv' && config.mainDomain != 'mobiotv' ? <p className="basic-para">
                                    Our Story is about Over-The-Top Content (OTT). BidioTV is a Video-On-Demand (VOD) Streaming site provides the most incredible movies, videos and TV channels worldwide to any connected device. Select your TV and VOD to enjoy our international, local and thematic TV channels and On Demand Videos that enrich every subscriber’s need.
                                </p>:
								<p className="basic-para">
									Our Story is about Over-The-Top Content (OTT). MobioTV is a TV Channel and Video-On-Demand (VOD) Streaming site provides the most incredible movies, videos and TV channels worldwide to any connected device. Select your TV and VOD to enjoy our international, local and thematic TV channels and On Demand Videos that enrich every subscriber’s need.
								</p>}
							</Col>
						</Row>
					</Container>
				</div>
			</section>
        )
	}

    __getPrivacyPolicy() {
        let termTitleClass = (config.subDomain == 'iq') ? "terms-title arabic" : "terms-title";
        return (
            <section className="terms-conditions">
                {config.subDomain === 'rs' ?<Container fluid>
                    <Row className="no-gutters">
                        <Col xs="12" className="terms-list">
                            <h6 className={termTitleClass}>Politika privatnosti</h6>
                            <p className="terms-para">
                                Ova stranica vas informiše o našim politikama u vezi sa prikupljanjem, korišćenjem i objavljivanjem ličnih informacija koje primamo od korisnika veb lokacije. Koristimo vaše lične informacije samo zarad dostavljanja pristupa na veb lokaciju. Kada koristite veb lokaciju, slažete se oko prikupljanja i korišćenja informacija u skladu sa ovom politikom. Prikupljanje informacije i korišćenje dok koristite ovu veb lokaciju, možemo da tražimo od vas da nam dostavite određene informacije koje vas lično identifikuju a koje mogu da se koriste da bismo vas kontaktirali ili identifikovali. Lične informacije o identifikaciji mogu da uključuju, ali nisu ograničene na vaše ime („lične informacije“). 
                            </p>
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className={termTitleClass}>Podaci o upisivanju </h6>
                            <p className="terms-para">
                                Kao većina operatera veb lokacija, prikupljamo informacije koje vaš pretraživač šalje kadagod posetite našu veb lokaciju („podaci o upisivanju“). Ovi podaci o upisivanju mogu da uključuju informacije kao što su broj mobilnog telefona (MSISDN), tip pretraživača, verzija pretraživača, strane naše veb lokacije koju ste posetili, vreme i datum vaše posete, vreme provedeno na ovim stranicama i drugu statistiku. Pored toga, možemo da koristimo usluge treće strane kao što su Google Analytics koje prikupljanju, kontrolišu i analiziraju ovo.
                            </p>
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className={termTitleClass}>Kolačići </h6>
                            <p className="terms-para">
                                Kolačići su datoteke sa manjom količinom podataka, koji mogu da uključuju anonimni jedinstveni identifikator. Kolačići se šalju na vaš pretraživač sa veb lokacije i čuvaju na hard drajvu vašeg računara. Kao većina veb lokacija, koristimo „kolačiće“ da prikupljamo informacije. Možete da obavestite svoj pretraživač da odbije sve kolačiće ili da navedete kada se kolačići šalju. Međutim, ako ne prihvatite kolačiće, možda nećete moći da koristite neke delove naše veb lokacije. 
                            </p>
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className={termTitleClass}>Bezbednost</h6>
                            <p className="terms-para">
                                Bezbednost vaših ličnih informacija nam je važna, ali setite se da nijedan metod prenosa preko interneta, ili metod elektronskog skladištenja, nije 100% bezbedan. Iako se trudimo da koristimo komercijalno prihvatljive načine da zaštitmo vaše lične informacije, ne možemo da garantujemo njihovu potpunu bezbednost. Izmene nad ovom politikom privatnosti Ova politika privatnosti je na snazi od datuma vaše pretplate na uslugu i ostaće na snazi bez obzira na bilo koje promene u odredbama u budućnosti, koje će odmah stupiti na snagu nakon što se objave na ovoj strani. Zadržavamo pravo da ažuriramo ili promenimo našu politiku privatnosti bilo kada i treba da proverite ovu politiku privatnosti periodično. Vaše neprekidno korišćenje usluge nakon što objavimo bilo kakve izmene nad politikom privatnosti na ovoj strani smatraće se vašim prihvatanjem izmena i vašu saglasnost da ih poštujete putem izmenjene politike privatnosti. Ako izvršimo bilo kakve materijalne izmene nad ovom politikom privatnosti, obavestićemo vas tako što ćemo staviti vidljivu napomenu na veb lokaciji. 
                            </p>
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className={termTitleClass}>Kontaktirajte nas</h6>
                            <p className="terms-para">
                                Ako imate bilo kakva pitanja u vezi ove politike privatnosti, kontaktirajte nas. Telefon:  00381113216815 E-pošta: 
                            </p>
                        </Col>
                    </Row>
                </Container>
                :<Container fluid>
                    <Row className="no-gutters">
                        <Col xs="12" className="terms-list">
                            <p className="terms-para">
                            <FormattedMessage id="privacyPolicyBody" defaultMessage="This Privacy Policy explains our commitments and your rights concerning your information.
                             You should read the Privacy Policy carefully. If you do not agree with this Privacy Policy, 
                             please do not use our Sites or Services. The Privacy Policy is duly incorporated and subject
                              to the Terms of Service and governs the same Services and Sites as the ones mentioned in the 
                              Terms of Service. Any terms we use in the Privacy Policy without defining them have the same 
                              definition as in the Terms of Service."/>
                            </p>
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className={termTitleClass}><FormattedMessage id="privacyPolicyCollectInfoTitle" defaultMessage="WE COLLECT INFORMATION THE FOLLOWING WAYS"/>:</h6>
                            <p className="terms-para">
                            1. <FormattedMessage id="privacyPolicyCollectInfo_one" defaultMessage="When you give it to us or give us permission to obtain it If you choose to subscribe to a Service
                             from us, we or the mobile operator of your network will collect your information related to the
                              payment for the subscription of our Services. Account and billing information collected by the
                               mobile operator are subject to their respective privacy policies. "/>                       
                            </p>
                            <p className="terms-para">
                               2. <FormattedMessage id="privacyPolicyCollectInfo_two" defaultMessage="We get technical information when you visit our Sites and/or Services We may collect technical information
                                about you whenever you use our Services. We collect log data every time you log in or log out of our Services."/> 
                            </p>
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className={termTitleClass}><FormattedMessage id="privacyPolicyHowWeUseTitle" defaultMessage="HOW WE USE COLLECTED INFORMATION"/></h6>
                            <p className="terms-para">
                            <FormattedMessage id="privacyPolicyHowWeUse" defaultMessage="We may use your information for the following purposes: 

                            Provide the Service(s) you request

                            Bill and collect for the Service(s) provided to you"/> </p>
                            
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className={termTitleClass}><FormattedMessage id="privacyPolicyHowLongWeKeepTitle" defaultMessage="HOW LONG WE KEEP YOUR INFORMATION"/></h6>
                            <p className="terms-para">
                            <FormattedMessage id="privacyPolicyHowLongWeKeep" defaultMessage="We will retain your information for as long as needed to provide our Services to you. We will retain your information as necessary to comply with our legal obligations, resolve disputes and enforce our agreements.
                            When we no longer need to use your information and there is no need for us to keep it to comply with our legal or regulatory obligations, we will either remove it from our systems or depersonalize it so that we can no longer identify you."/>
                            
                            </p>
                           
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className={termTitleClass}><FormattedMessage id="privacyPolicyHowWeProtectTitle" defaultMessage="HOW WE PROTECT YOUR INFORMATION ALSO OUTSIDE THE EU"/></h6>
                            <p className="terms-para">
                            <FormattedMessage id="privacyPolicyHowWeProtect" defaultMessage="We are concerned with protecting your privacy and data, but we cannot ensure or warrant the security of any information you transmit to us or guarantee that your information may not be accessed, disclosed, altered or destroyed by breach of any of our industry standard physical, technical or managerial safeguards. We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized or accidental access, alteration, disclosure or destruction of your information, transaction information and data stored on our Services.

                             However, no method of transmission over the internet or method of electronic storage is 100% secure. Therefore, we cannot guarantee its absolute security. We will continue to enhance our security procedures as new technology becomes available.  
                             
                             Because we operate internationally, your information, including personal information, may be transferred to and made available in the USA/Singapore and/or any other country than your country of residence. Also in these countries, we take all reasonable care to protect your personal information.   
                            "/>
                                
                            </p>
                            
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className={termTitleClass}><FormattedMessage id="privacyPolicyUsingServicesTitle" defaultMessage="ACCEPTANCE OF PRIVACY POLICY"/></h6>
                            <p className="terms-para">
                            <FormattedMessage id="privacyPolicyUsingServices" defaultMessage="By using any of our Services, you consent to our collection and use of your information in accordance with this Privacy Policy. We reserve the right to modify this Privacy Policy at any time by posting the changes on this page. Please check the revision date at the bottom of this page to determine if the policy has been modified since you last reviewed it. Your continued use of any portion of our Site or Services following the posting of the updated Privacy Policy will constitute your acceptance of the changes.    "/>           
                            </p>
                            
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className={termTitleClass}><FormattedMessage id="privacyPolicyChangesTitle" defaultMessage="CHANGES TO THIS PRIVACY POLICY"/></h6>
                            <p className="terms-para">
                            <FormattedMessage id="privacyPolicyChanges" defaultMessage="We may make changes in our Privacy Policy from time to time. If we decide to change our Privacy Policy, we will post those changes on this page so that you can always access the latest Privacy Policy."/>
                                                        </p>
                            
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className={termTitleClass}><FormattedMessage id="privacyPolicyConnectingUsTitle" defaultMessage="CONTACTING US"/></h6>
                            <p className="terms-para">
                            {config.subDomain === 'my' ?
                            "You may contact our Customer Care Team at 03-2775 2064 /+6018-780 0852 or through email at cs@sam-media.com. Our dedicated Customer Care Team will be more than happy to answer your questions or solve any issues. Please note that the operating hours for our Customer Care Team is only from Monday to Friday, 9.30AM to 6.00PM."
                            :
                            <FormattedMessage id="privacyPolicyConnectingUs" defaultMessage="If you have a question about this Privacy Policy, the practices of the Sites, or your dealings with the Sites, please contact us by sending an e-mail to support@content-clubs.com."/>
                            }
                            </p>
                            
                        </Col>
                    </Row>
                </Container>}
            </section>
        )
    }

    __getTermsConditions() {
        return (
          <section className="terms-conditions">
            {config.subDomain === "rs" ? (
              <Container fluid>
                <Row className="no-gutters">
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">USLOVI</h6>
                    <h6 className="terms-title">1. Opseg uslova</h6>
                    <p className="terms-para">
                      Sledeći opšti uslovi i odredbe su deo svakog ugovora
                      između kompanije Sam Media B.V. (dalje u ovom tekstu kao
                      „davalac usluge“) i korisnika davaočevih usluga. Ovim
                      opštim uslovima se obavezuju još i pravni naslednici
                      davaoca usluga i korisnika.
                    </p>
                    <p className="terms-para">
                      Davalac usluga nudi korisniku mogućnost pristupa sadržaja
                      ponuđenog na veb stranici, i korišćenja istog, putem
                      mobilnog uređaja (mobilnog telefona) korisnika, uz
                      naknadu. Predmet ovih opštih uslova i odredaba su svi
                      propisi koje će ugovorne strane doneti u tom pogledu.
                    </p>
                    <p className="terms-para">
                      Ovi opšti uslovi i odredbe važe isključivo za korisnike iz
                      Srbije.
                    </p>
                    <p className="terms-para">
                      Davalac usluga pruža svoje usluge isključivo na osnovu
                      ovih opštih uslova i odredaba.
                    </p>
                    <p className="terms-para">
                      Važenje ovih opštih uslova i odredaba proširuje se na sve
                      usluge koje davalac usluga nudi na veb stranici.
                      Korišćenjem usluga davaoca, korisnik prihvata ove opšte
                      uslove i odredbe kao obavezujuće za sebe.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">2. Zaključenje ugovora</h6>
                    <p className="terms-para">
                      Predstavljanje usluga davaoca na veb stranici ne čini
                      obavezujućom ponudu davaoca, već samo poziv korisniku da
                      podnese ponudu.
                    </p>
                    <p className="terms-para">
                      Ugovor se zaključuje tako što korisnik aktivira dugme za
                      potvrdu ili reprodukciju prikazano na mobilnom uređaju
                      korisnika nakon pristupa usluzi davaoca i nakon što
                      davalac usluga naknadno postavi uslove i odredbe usluge.
                    </p>
                    <p className="terms-para">
                      Odmah nakon postavljanja opcije korišćenja, korisnik može
                      da pristupi svim uslugama koje se nude na sajtu, i da ih
                      koristi, preko svog mobilnog uređaja.
                    </p>
                    <p className="terms-para">
                      Važeće su one cene koje su saopštene korisniku. One
                      uključuju obavezni PDV, primenjuju se za navedeni period i
                      odnose se samo na davanje mogućnosti korišćenja davaočevih
                      usluga. U cene nisu uključene naknade za povezivanje koje
                      nastaju prilikom pristupa davaočevim uslugama, a koje
                      korisniku naplaćuje njegov davalac usluga mobilne
                      telefonije.
                    </p>
                    <p className="terms-para">
                      Naknada koju korisnik plaća za korišćenje davaočevih
                      usluga dospeva odmah po zaključivanju ugovora i bez
                      odbitaka. Ovu naknadu u ime davaoca usluge naplaćuje
                      davalac usluga mobilne telefonije korisnika kao deo
                      redovnog obračuna.
                    </p>
                    <p className="terms-para">
                      Korisnik dobija jednostavno, neprenosivo, lokalno
                      neograničeno pravo korišćenja tokom trajanja ovog ugovora
                      za usluge koje pruža davalac.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">3. Uslovi plaćanja</h6>
                    <p className="terms-para">
                      Važeće su one cene koje su saopštene korisniku. One
                      uključuju obavezni PDV, primenjuju se za navedeni period i
                      odnose se samo na davanje mogućnosti korišćenja davaočevih
                      usluga. U cene nisu uključene naknade za povezivanje koje
                      nastaju prilikom pristupa davaočevim uslugama, a koje
                      korisniku naplaćuje njegov davalac usluga mobilne
                      telefonije.
                    </p>
                    <p className="terms-para">
                      Naknada koju korisnik plaća za korišćenje davaočevih
                      usluga dospeva odmah po zaključivanju ugovora i bez
                      odbitaka. Ovu naknadu u ime davaoca usluge naplaćuje
                      davalac usluga mobilne telefonije korisnika kao deo
                      redovnog obračuna.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">4. Prava na korišćenje</h6>
                    <p className="terms-para">
                      Korisnik dobija jednostavno, neprenosivo, lokalno
                      neograničeno pravo korišćenja tokom trajanja ovog ugovora
                      za usluge koje pruža davalac.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">5. Pristupačnost</h6>
                    <p className="terms-para">
                      Davalac usluga garantuje dostupnost usluga koje pruža u
                      obimu 99,5% u proseku godišnje. Ukoliko takva dostupnost
                      nije moguća, korisnik može kod davaoca usluge da ostvari
                      pravo na sniženje cene. Iznos tog sniženja je ograničen na
                      iznos koji je korisnik morao da plati po osnovu ovog
                      ugovora u periodu u kojem nije postojala garantovana
                      dostupnost.
                    </p>
                    <p className="terms-para">
                      Davalac osmišljava svoju ponudu u skladu sa tehničkim
                      standardima dostupnim na tržištu i na taj način pokušava
                      da obezbedi da korisnik može da iskoristi prednosti usluga
                      davaoca. Međutim, davalac ne može garantovati da se
                      uslugama koje nudi može pristupiti preko svih mobilnih
                      uređaja na tržištu.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">
                      6. Ograničenje odgovornosti i obeštećenje
                    </h6>
                    <p className="terms-para">
                      Davalac usluga je odgovoran samo za one štete koje
                      isključuju štete nastale kao posledice povrede života,
                      tela i zdravlja ako su zasnovane na namernom ili krajnje
                      nemarnom ponašanju davaoca usluga, njegovih zaposlenih ili
                      njegovih pomoćnih zastupnika. Ovo se odnosi i na štete
                      nastale zbog kršenja obaveza tokom pregovora o ugovoru i
                      izvođenja neovlašćenih radnji.
                    </p>
                    <p className="terms-para">Telefon: 00381113216815</p>
                    <p className="terms-para">
                      Email: <strong>sammedia.rs@silverlines.info</strong>
                    </p>
                  </Col>
                </Row>
              </Container>
            ) : config.subDomain == "za.fun-box" ? (
              <Container fluid>
                <Row className="no-gutters">
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">Introduction</h6>
                    <p className="terms-para">
                      FunBox is a subscription service charged at R7/day for
                      Vodacom customers and R7/day for MTN, Cell C, and Telkom
                      customers. Subscribers receive unlimited access to premium
                      mobile content. By using the service, you confirm that you
                      are 18 years or older and have the bill payer's
                      permission. Compatible handsets are required, and
                      additional network fees may apply.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">Subscription and Billing</h6>
                    <p className="terms-para">
                      Upon subscription, you will receive a Welcome Message. The
                      subscription fee will be charged directly to your mobile
                      account or deducted from your prepaid balance, depending
                      on your mobile network operator. Charges will recur daily
                      until you unsubscribe. To unsubscribe, follow the
                      instructions in the content portal or dial *135**997#
                      (Vodacom), *123# (MTN), *133# (Cell C), or the relevant
                      Telkom shortcode.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">Access and Use</h6>
                    <p className="terms-para">
                      The service must not be used to engage in illegal
                      activities, including but not limited to the creation,
                      storage, or distribution of illegal content or
                      infringement of copyright or intellectual property rights.
                      The service provider reserves the right to terminate your
                      subscription if these terms are breached. The service must
                      only be used with the permission of the bill-payer. Users
                      of the service may not:
                      <ul>
                        <li>
                          Knowingly create, store, or disseminate any illegal
                          content,
                        </li>
                        <li>Knowingly infringe copyright,</li>
                        <li>
                          Knowingly infringe any intellectual property rights,
                          or
                        </li>
                        <li>Send spam or promote the sending of spam.</li>
                      </ul>
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">
                      Service Availability and Restrictions
                    </h6>
                    <p className="terms-para">
                      The service is available on compatible devices only. The
                      service provider does not guarantee uninterrupted access
                      or error-free operation. Service may be suspended or
                      restricted due to technical, operational, or legal
                      reasons. The service provider reserves the right to modify
                      or discontinue the service at any time without prior
                      notice.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">
                      Content and Intellectual Property
                    </h6>
                    <p className="terms-para">
                      All content provided through FunBox is protected by
                      copyright and other intellectual property laws. You are
                      granted a non-transferable, non-exclusive license to use
                      the content for personal, non-commercial use only. Any
                      unauthorized use, distribution, or reproduction of the
                      content is strictly prohibited and may result in the
                      termination of your subscription and/or legal action.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">Termination</h6>
                    <p className="terms-para">
                      The service provider reserves the right to suspend or
                      terminate your subscription without notice if it
                      determines, at its sole discretion, that you have violated
                      these terms. Upon termination, your access to the service
                      will cease immediately. You may also terminate your
                      subscription at any time by following the unsubscribe
                      instructions provided in the content portal or via the
                      designated USSD strings.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">Refunds</h6>
                    <p className="terms-para">
                      Refunds may be provided at the sole discretion of the
                      service provider and in compliance with applicable laws.
                      If you are dissatisfied with the service or if the service
                      was not as described, you must contact customer support
                      within seven days of subscription for a possible refund.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">Privacy and Data Protection</h6>
                    <p className="terms-para">
                      By using FunBox, you agree to the collection, use, and
                      sharing of your personal data in accordance with our
                      Privacy Policy. We are committed to protecting your
                      privacy and handling your data transparently.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">Limitation of Liability</h6>
                    <p className="terms-para">
                      The service is provided on an "as is" and "as available"
                      basis. The service provider makes no warranties or
                      representations, express or implied, regarding the
                      service's operation or the information, content, or
                      materials provided. The service provider shall not be
                      liable for any direct, indirect, incidental, or
                      consequential damages arising from your use of the
                      service.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">
                      Governing Law and Dispute Resolution
                    </h6>
                    <p className="terms-para">
                      These terms shall be governed by the laws of South Africa.
                      Any disputes arising from or related to these terms will
                      be subject to the exclusive jurisdiction of the South
                      African courts.
                    </p>
                    <p className="terms-para">
                      Sam Media is a member of WASPA and is bound by the WASPA
                      Code of Conduct. Customers have the right to approach
                      WASPA to lodge a complaint in accordance with the WASPA
                      complaints procedure. Sam Media may be required to share
                      information relating to a service or a customer with WASPA
                      for the purpose of resolving a complaint. WASPA
                      website: www.waspa.org.za.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">Customer Support</h6>
                    <p className="terms-para">
                      For assistance, contact our customer service team at 011
                      507 4779 or email info@smartcalltech.co.za.
                    </p>
                  </Col>
                </Row>
              </Container>
            ) : (
              <Container fluid>
                <Row className="no-gutters">
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">
                      General Terms And Conditions And Privacy Policy.
                    </h6>
                    <p className="terms-para">
                      The following General Terms and Conditions are applicable
                      to the products and services supplied via WAP, SMS, GPRS
                      and 3G by Sam Media Ltd., or enterprises affiliated to it,
                      (hereinafter to be referred to as “the Provider”). The
                      Provider is permitted to amend these General Terms and
                      Conditions from time to time without notice. Apart from
                      the General Terms and Conditions, any applicable and
                      publicized rules, promotional conditions, guidelines and
                      provisions pertaining to the services also apply to you
                      and the Provider upon the use of the Services (as defined
                      herein) of the Provider. All those guidelines, rules,
                      promotional conditions and provisions will be considered
                      an inextricable part of these General Terms and
                      Conditions. By availing yourself to use the Services of
                      the Provider, you agree to be bound by these General Terms
                      and Conditions and the guidelines, rules and promotional
                      conditions.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">
                      Description Of The Provider.
                    </h6>
                    <p className="terms-para">
                      By means of WAP, SMS, GPRS and 3G services, the Provider
                      supplies its user’s access to a network of on-line
                      sources, including on-line games, text messages, rich
                      content and on-line information material which may be
                      downloaded onto mobile telephone or whatsoever devices
                      (“Services”). The General Terms and Conditions are at all
                      times applicable to all new facilities including
                      facilities which the Provider may implement as part of the
                      Provider’s expansion, extension or improvement of the
                      present Services, including any extension to new functions
                      added by the Provider.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">Availability.</h6>
                    <p className="terms-para">
                      The Service is supplied as is (at the stage of development
                      it happens to be in) and the Provider accepts no liability
                      nor does it issue any guarantees or warranty in the event
                      that personal configurations, information or messages are
                      not saved, or not saved in due time, or if they are
                      deleted or incorrectly delivered. In order to subscribe to
                      the Service, you are required to have access to the
                      Internet and/or a mobile communications subscription and
                      pay any service fees associated with such access. You are
                      required to pay all expenses incurred in creating such
                      access. You are also responsible for seeing to the
                      connection of any necessary equipment, including any
                      mobile telephone or personal computer or whatever devices
                      that may be necessary needed and are in working order and
                      suitable for use in connection with the Service.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">Payment.</h6>
                    <p className="terms-para">
                      You have access to our on-line services free of charge.
                      With regards to the Services and the use of it, you shall
                      pay the amount corresponding to the applicable rates of
                      the Provider in force at that time and according to the
                      rates charged by your mobile operator. The charges shall
                      be invoiced to you via your mobile operator through the
                      mobile bill you receive from the mobile operator of your
                      network. You pay the Provider all national and local or
                      other taxes, including but not restricted to VAT, any
                      taxes or levies imposed in lieu thereof, which taxes are
                      based on the costs due to the use of the Services,
                      regardless of whether those taxes are levied either now or
                      in the future by European, national or local authorities
                      or by any other body or bodies authorized to levy taxes.
                      The Provider reserves the right to change the rates for
                      the Service by posting details of such changes on its
                      website.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">Registration Obligation.</h6>
                    <p className="terms-para">
                      In order to warrant safe and secure use of the Service,
                      you guarantee the following, in addition to paying the
                      applicable charges: (a) your personal information
                      (hereinafter to be referred to as the “Registered
                      Information”) provided on the registration form is
                      correct, true, accurate and complete and (b) you agree to
                      ensure that the Registered Information is at all times
                      correct, up to date, true, accurate and complete. If the
                      Provider has a reasonable suspicion that the Registered
                      Information does not reflect a true state of affairs, or
                      is not accurate or complete, then the Provider is entitled
                      to suspend or terminate your account and to withhold both
                      current and future use of the Service, or any component of
                      it. You yourself are responsible for maintaining the
                      secrecy of any passwords and/or accounts issued to you by
                      the Provider, and you are fully liable for all actions
                      carried out involving the use of your password or account.
                      You undertake at the end of each session to close your
                      account (by closing your browser) and to contact the
                      Provider if you notice or suspect that unauthorized use
                      has been made of your password or account, or that
                      security or protection is no longer guaranteed for any
                      other reason. The Provider cannot and will not be liable
                      for any damage arising from your failure to observe the
                      stipulations of this article.
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">
                      Ownership Rights Of The Provider.
                    </h6>
                    <p className="terms-para">
                      You are aware and agree that the Service and software used
                      in connection with the Service, (hereinafter to be
                      referred to as the “Software”), contain confidential
                      information which belongs to the Provider is protected by
                      valid and applicable intellectual and industrial ownership
                      rights legislation and other legislation. You are also
                      aware and agree that copyright, trademarks, service marks,
                      patents or other ownership rights and laws are applicable
                      to Information published in sponsors' advertisements or
                      information offered to you via the Service. You undertake,
                      either partially or wholly, not to amend, rent, rent out,
                      borrow, lend, sell, distribute or create products derived
                      from the Service or the Software except in the event that
                      the Provider has given you explicit written permission to
                      do so. The Provider hereby grants you a personal,
                      non-transferable and non-exclusive right and permission to
                      use the working code of its Software, provided you do not
                      copy or alter any source code whatever, or create a
                      product derived from it, or carry out any reverse
                      engineering or reverse assembly on it or in any other way
                      attempt to find a source code (or permit third parties to
                      do so) (except if and insofar as such acts are permitted
                      by the provisions of any mandatory law that may be in
                      effect), and you agree not sell, encode, sublicense,
                      encumber with security rights or transfer in any other way
                      any rights connected with the Software to any person or
                      entity. You undertake not to alter the Software in any way
                      whatever or to use any altered versions of the Software
                      for the purpose of gaining unauthorized access to the
                      Service or for any other reason. In gaining access to the
                      Service, you undertake only to make use of the interface
                      supplied for that purpose by the Provider. The Provider
                      hereby grants you permission to make one copy only of the
                      Information on the equipment you use for gaining access to
                      the Service, and to use and display the copy of the
                      Information made on that equipment for private purposes.
                    </p>
                  </Col>
                </Row>
              </Container>
            )}
          </section>
        );
    }

	render() {
        switch (this.state.type) {
			case "about": {
				return this.__getAboutUsPage();
			}
            case "privacy-policy": {
                return this.__getPrivacyPolicy();
            }
            case "terms-conditions": {
                return this.__getTermsConditions();
            }
            default:
                return (
                    <section>

                    </section>
                );
		}
	}
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        setHeaderTitle
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(StaticPages);


// WEBPACK FOOTER //
// ./src/components/StaticPages/StaticPages.js